import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createProductionGroup, type CreateProductionGroup } from "@/api/selection/production-group-api";

import { PRODUCTION_GROUPS_QUERY_KEY } from "./use-production-groups";

export const useCreateProductionGroup = () => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (data: CreateProductionGroup) => createProductionGroup(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: PRODUCTION_GROUPS_QUERY_KEY });
		},
	});

	return {
		mutate: mutation.mutateAsync,
		isPending: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
		error: mutation.error,
	};
};
